"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QRFromBase64 = QRFromBase64;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
function QRFromBase64({ base64Data, systemName, url, size = 240, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const hasValidUrl = typeof url === 'string' && url.startsWith('http');
    const isValidBase64 = (0, react_1.useMemo)(() => {
        if (!base64Data)
            return false;
        const cleaned = base64Data.replace(/data:[^,]+,/, '');
        const regex = /^[A-Za-z0-9+/=]+$/;
        return regex.test(cleaned);
    }, [base64Data]);
    const openExternal = () => {
        if (!hasValidUrl)
            return;
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    if (!base64Data) {
        return (0, jsx_runtime_1.jsx)("p", { className: "text-gray-500 text-sm", children: t('base64NotReceived') });
    }
    if (!isValidBase64) {
        return (0, jsx_runtime_1.jsx)("p", { className: "text-red-500 text-sm", children: t('base64NotValid') });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center inline-block", children: [hasValidUrl ? ((0, jsx_runtime_1.jsx)("img", { onClick: openExternal, role: hasValidUrl ? 'button' : undefined, className: "cursor-pointer rounded-lg shadow-md mb-2", src: `data:image/png;base64,${base64Data}`, alt: `QR ${systemName || ''}`, style: { width: size, height: size } })) : ((0, jsx_runtime_1.jsx)("img", { src: `data:image/png;base64,${base64Data}`, alt: `QR ${systemName || ''}`, className: "rounded-lg shadow-md opacity-50 cursor-not-allowed mb-2", style: { width: size, height: size } })), systemName && ((0, jsx_runtime_1.jsx)("p", { className: "text-xs font-medium text-gray-700", children: systemName }))] }));
}
